<!-- Единое поле формы: задаёт колонку сетки, label, состояние обязательности и текст ошибки. -->
<template>
  <div :class="fieldClasses">
    <div
      v-if="label"
      class="base-form-field__header"
    >
      <base-label
        :for="forId"
        :required="required"
        :filled="filled"
        :info="info"
        :info-key="infoKey"
      >
        {{ label }}
      </base-label>

      <slot name="action" />
    </div>

    <slot />

    <span class="base-form-field__error" v-if="error">
      {{ errorMessage }}
    </span>
  </div>
</template>

<script>
export default {
  name: "BaseFormField",
  props: {
    label: {
      type: String,
      default: "",
    },
    forId: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: "Поле обязательно для заполнения",
    },
    info: {
      type: String,
      default: "",
    },
    // Ключ из src/config/fieldInfo.js для единого текста подсказки
    infoKey: {
      type: String,
      default: "",
    },
    wide: {
      type: Boolean,
      default: false,
    },
    span: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    fieldClasses() {
      return [
        "form-group",
        "form-layout__field",
        {
          "form-layout__field--wide": this.wide,
          "form-layout__field--span-2": String(this.span) === "2",
        },
      ];
    },
  },
};
</script>

<style scoped>
.base-form-field__header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
  min-width: 0;
}

.base-form-field__header :deep(.label) {
  margin-bottom: 0;
  min-width: 0;
}

.base-form-field__header :slotted(.base-action-link) {
  flex: 0 0 auto;
  min-height: 16px;
  line-height: 16px;
}

.base-form-field__error {
  display: block;
  margin-top: 5px;
  color: var(--color-danger);
  font-size: 12px;
}

</style>
